module.exports = __webpack_public_path__ + "img/CF_1N.74f14d43.jpg";